import type { DebounceSettings } from 'lodash';
import debounce from 'lodash/debounce';
import objectHash from 'object-hash';
import { useCallback, useEffect, useState } from 'react';

import { DEBOUNCE_TIME_IN_MS } from '@/lib/const';

export function useDebouncedValue<T>(
  value: T,
  wait: number = DEBOUNCE_TIME_IN_MS,
  debounceOPtions?: DebounceSettings,
) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const handleDebounceFn = (data: T) => {
    setDebouncedValue(data);
  };
  const debounceFn = useCallback(
    debounce(handleDebounceFn, wait, debounceOPtions),
    [],
  );
  const objHash = objectHash(value || '');
  useEffect(() => {
    debounceFn(value);
  }, [objHash]);

  return debouncedValue;
}
